import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import FeatherIcon from "feather-icons-react";
import useApi from "../../../core/customhook/useApi";
import Loader from "../../../core/common/selfLoder";
import Swal from "sweetalert2";

const OutdutyTeamMember = () => {
  const [searchValue, setSearchValue] = useState<any>({});
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [empname, setEmpname] = useState("");
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState<any[]>([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const {
    data: teamData,
    loading: teamLoading,
    error: teamError,
  } = useApi("/api/manager/team-member", {
    method: "GET",
    autoCall: true,
  });
  const data = teamData?.data;
  const columns = [
    {
      title: "EmpCode",
      dataIndex: "employee_id",
      render: (text: string, record: any) => (
        <Link
          to="#"
          onClick={() => {
            setSearchValue(record);
            setEmpname(record.employee_name);
            setModalOpen(false);
          }}
          style={{ textDecoration: "underline", cursor: "pointer" }}
          data-bs-dismiss="modal"
        >
          {text}
        </Link>
      ),
      sorter: (a: any, b: any) => a.employee_id.localeCompare(b.employee_id),
    },
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      render: (text: string, record: any) => (
        <Link
          to="#"
          onClick={() => {
            setSearchValue(record);
            setEmpname(record.employee_name);
            setModalOpen(false);
          }}
          style={{ textDecoration: "underline", cursor: "pointer" }}
          data-bs-dismiss="modal"
        >
          {text}
        </Link>
      ),
      sorter: (a: any, b: any) =>
        a.employee_name.localeCompare(b.employee_name),
    },
    {
      title: "Designation",
      dataIndex: "designation", // Change From to designation
      sorter: (a: any, b: any) => a.designation.localeCompare(b.designation),
    },
    {
      title: "Department",
      dataIndex: "department", // Change To to department
      sorter: (a: any, b: any) => a.department.localeCompare(b.department),
    },
    {
      title: "Locatation",
      dataIndex: "branch_name", // Change To to branch_name
      sorter: (a: any, b: any) => a.branch_name.localeCompare(b.branch_name),
    },
  ];

  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSelectedOption(value);
  };



  const options = [
    { label: "Apply Outduty on behalf of Team Member", value: "apply" },
    { label: " View Team Member Outduty Details", value: "details" },
    { label: "View Team Member Outduty Calender", value: "calender" },
  ];


  const handleselectButton = (value: string) => {
    setSelectedOption(value)
  }

  return (
    <>
      <Loader loading={teamLoading} />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Out Duty Team Member</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Work & Operations</li>
                  <li className="breadcrumb-item">OD</li>
                  <li className="breadcrumb-item">
                    <Link to={all_routes.teamOutDutyGrid}>Team Out Duty</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Out Duty Team Member
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header">
              {/* Horizontally scrollable container */}
              <div
                className="w-100"
                style={{
                  overflowX: "auto",
                  WebkitOverflowScrolling: "touch", // smooth scroll on iOS
                }}
              >
                <div
                  className="d-inline-flex align-items-center gap-2 py-2 px-1"
                  style={{
                    minWidth: "max-content",
                    whiteSpace: "nowrap",
                  }}
                >
                  {options.map((option) => (
                    <button
                      key={option.value}
                      className="btn px-2 px-sm-3"
                      style={{
                        backgroundColor:
                          selectedOption === option.value ? "#2e3294" : "transparent",
                        color: selectedOption === option.value ? "#FFF" : "#2e3294",
                        border: "1px solid #2e3294",
                        borderRadius: "15px",
                        fontWeight: "500",
                        whiteSpace: "nowrap",
                        fontSize: "14px",
                      }}
                      onClick={() => handleselectButton(option.value)}
                    >
                      {option.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex align-items-center gap-2 mb-3 w-100">
            <label className="me-2 mb-0" htmlFor="employeeSearch">
              <strong>Employee Name:</strong>
            </label>

            <div style={{ position: "relative", width: "500px" }}>
              <input
                type="text"
                name="empname"
                id="employeeSearch"
                className="form-control me-2"
                placeholder="Type name / code"
                style={{ width: "100%" }}
                value={empname} // ✅ Only track empname
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const value = e.target.value;
                  setEmpname(value);
                  setSearchValue(""); // Optional: reset selected search value

                  if (value.trim()) {
                    const matches = data.filter((item: any) =>
                      item.employee_name
                        .toLowerCase()
                        .includes(value.toLowerCase())
                    );
                    setFilteredSuggestions(matches);
                    setShowSuggestions(true);
                  } else {
                    setFilteredSuggestions([]);
                    setShowSuggestions(false);
                  }
                }}
              />
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "8px",
                  transform: "translateY(-50%)",
                  padding: "4px 8px",
                }}
                onClick={() => setModalOpen(true)}
                data-bs-toggle="modal"
                data-bs-target="#bs-example-modal-lg"
              >
                <FeatherIcon icon="more-horizontal" size="16" />
              </button>

              {showSuggestions && filteredSuggestions.length > 0 && (
                <ul
                  className="dropdown-menu show"
                  style={{
                    width: "100%",
                    maxHeight: "200px",
                    overflowY: "auto",
                    position: "absolute",
                    zIndex: 1000,
                  }}
                >
                  {filteredSuggestions.map((item, index) => (
                    <li
                      key={index}
                      className="dropdown-item"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setSearchValue(item);
                        setEmpname(item.employee_name);
                        setShowSuggestions(false);
                      }}
                    >
                      {item.employee_id}-{item.employee_name}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <button
              className="btn btn-primary custom_button"
              onClick={() => {
                if (!selectedOption) {
                  Swal.fire({
                    icon: "warning",
                    title: "Option Missing",
                    text: "Please select an option.",
                    showConfirmButton: true,
                  });
                  return;
                }
                const nameToUse = searchValue;
                if (!nameToUse || !nameToUse.employee_name?.trim()) {
                  Swal.fire({
                    icon: "error",
                    title: "Employee Required",
                    text: "Please choose the employee name from the suggestions.",
                  });
                  return;
                }

                switch (selectedOption) {
                  case "apply":
                    navigate("/apply-outduty-team-member", {
                      state: { searchValue },
                    });
                    break;
                  case "details":
                    navigate("/outduty-details-team-member", {
                      state: { searchValue },
                    });
                    break;
                  case "calender":
                    navigate("/outduty-calender-team-member", {
                      state: { searchValue },
                    });
                    break;
                  // case "calendar":
                  //   navigate("/team-attendence-calender", {
                  //     state: { searchValue },
                  //   });
                  //   break;
                  default:
                    alert("Invalid option selected.");
                }
              }}
            >
              Go
            </button>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>

      {/* Modal */}

      <div
        className={`modal fade ${modalOpen ? "show" : ""}`}
        id="bs-example-modal-lg"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden={!modalOpen}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <img
                src="/assets/img/logo/weconnectlogo.png"
                alt=""
                style={{ height: "50px" }}
              />
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setModalOpen(false)}
              />
            </div>
            <div className="modal-body">
              <div className="card-body p-0">
                <Table dataSource={data} columns={columns} Selection={false}  showSearchInput={true}/>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="d-flex align-items-center gap-2 mb-3 w-100">
            <label className="me-2 mb-0" htmlFor="employeeSearch">
              <strong>Employee Name:</strong>
            </label>

            <div style={{ position: "relative", width: "500px" }}>
              <input
                type="text"
                name="empname"
                id="employeeSearch"
                className="form-control me-2"
                placeholder="Type name / code"
                style={{ width: "100%" }}
                value={empname} // ✅ Only track empname
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const value = e.target.value;
                  setEmpname(value);
                  setSearchValue(""); // Optional: reset selected search value

                  if (value.trim()) {
                    const matches = data.filter((item: any) =>
                      item.employee_name
                        .toLowerCase()
                        .includes(value.toLowerCase())
                    );
                    setFilteredSuggestions(matches);
                    setShowSuggestions(true);
                  } else {
                    setFilteredSuggestions([]);
                    setShowSuggestions(false);
                  }
                }}
              />
              <button
                type="button"
                className="btn btn-primary btn-sm"
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "8px",
                  transform: "translateY(-50%)",
                  padding: "4px 8px",
                }}
                onClick={() => setModalOpen(true)}
                data-bs-toggle="modal"
                data-bs-target="#bs-example-modal-lg"
              >
                <FeatherIcon icon="more-horizontal" size="16" />
              </button>

              {showSuggestions && filteredSuggestions.length > 0 && (
                <ul
                  className="dropdown-menu show"
                  style={{
                    width: "100%",
                    maxHeight: "200px",
                    overflowY: "auto",
                    position: "absolute",
                    zIndex: 1000,
                  }}
                >
                  {filteredSuggestions.map((item, index) => (
                    <li
                      key={index}
                      className="dropdown-item"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setSearchValue(item);
                        setEmpname(item.employee_name);
                        setShowSuggestions(false);
                      }}
                    >
                      {item.employee_id}-{item.employee_name}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <button
              className="btn btn-primary"
              onClick={() => {
                if (!selectedOption) return alert("Please select an option.");
                const nameToUse = searchValue;
                if (!nameToUse.employee_name.trim()) {
                  alert("Please enter an employee name or code.");
                  return;
                }
                switch (selectedOption) {
                  case "apply":
                    navigate("/apply-outduty-team-member", {
                      state: { searchValue },
                    });
                    break;
                  case "details":
                    navigate("/outduty-details-team-member", {
                      state: { searchValue },
                    });
                    break;
                  case "balances":
                    navigate("/outduty-balance-team-member", {
                      state: { searchValue },
                    });
                    break;
                  case "calendar":
                    navigate("/team-attendence-calender", {
                      state: { searchValue },
                    });
                    break;
                  default:
                    alert("Invalid option selected.");
                }
              }}
            >
              Go
            </button>
          </div> */}
    </>
  );
};

export default OutdutyTeamMember;
